import { render, staticRenderFns } from "./EmotionWheelDashboardItem.vue?vue&type=template&id=e69717c6"
import script from "./EmotionWheelDashboardItem.vue?vue&type=script&lang=js"
export * from "./EmotionWheelDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e69717c6')) {
      api.createRecord('e69717c6', component.options)
    } else {
      api.reload('e69717c6', component.options)
    }
    module.hot.accept("./EmotionWheelDashboardItem.vue?vue&type=template&id=e69717c6", function () {
      api.rerender('e69717c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/EmotionWheelDashboardItem.vue"
export default component.exports